var _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLyra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    width: "540px",
    height: "540px",
    viewBox: "0 0 540 540",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m91 286.38c4.981 7.905 14.43 15.698 40.178 15.66h250.48c9.705 0 20.656 7.271 24.502 16.295l41.532 98.329c3.81 9.023-0.989 16.332-10.695 16.332h-256.7c-15.273-0.969-29.446-4.997-36.002-20.508l-53.29-126.11zm215.39-203.41 42.01 99.559c3.809 9.061 1.428 22.112-5.348 29.196l-60.907 64.92h-138.48c-21.938 0.26-34.94-8.204-16.298-28.825l159.91-168.39c6.739-7.0847 15.309-5.5186 19.117 3.5424z",
    clipRule: "evenodd",
    fill: "url(#a)",
    fillRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 427.99,
    x2: 161.69,
    y1: 149.45,
    y2: 485.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63E1D6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B89B",
    offset: 1
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLyra);
export default __webpack_public_path__ + "static/media/lyra.9565fd8e1d466ec79954e4475f018933.svg";
export { ForwardRef as ReactComponent };